import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
export function ImageUpload({ value = [], onChange, type = "normal", }) {
    const uploadButton = (_jsxs("div", { children: [_jsx(PlusOutlined, {}), _jsx("div", { style: { marginTop: 8 }, children: "Upload" })] }));
    const handleChange = ({ fileList: newFileList }) => {
        onChange?.(newFileList);
    };
    if (type === "normal") {
        return (_jsx(Upload, { listType: "picture-card", fileList: value, maxCount: 1, beforeUpload: () => false, onChange: handleChange, showUploadList: false, children: (value || []).length >= 1 ? (_jsx("div", { className: "w-full h-full relative group", children: _jsx("img", { style: {
                        maxWidth: "100%",
                        width: "100%",
                    }, src: value[0].url ||
                        URL.createObjectURL(value[0].originFileObj), alt: "Upload", className: "w-full h-full object-cover" }) })) : (uploadButton) }));
    }
    return (_jsx(Dragger, { listType: "picture-card", fileList: value, maxCount: 1, beforeUpload: () => false, onChange: handleChange, showUploadList: false, children: (value || []).length >= 1 ? (_jsx("div", { className: "w-full h-full relative group", children: _jsx("img", { style: {
                    maxWidth: "100%",
                    width: "100%",
                }, src: value[0].url ||
                    URL.createObjectURL(value[0].originFileObj), alt: "Upload", className: "w-full h-full object-cover" }) })) : (uploadButton) }));
}
